import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import { Plus } from 'lucide-react';
import { Button } from '@getro/rombo';
import { FieldTypeIcon } from '../components/fieldTypeIcon';

const fieldTypes = [
  { type: 'text', label: 'Text' },
  { type: 'long_text', label: 'Long text' },
  { type: 'email', label: 'Email' },
  { type: 'url', label: 'URL' },
];

export const AddFieldDropdown = ({ onAddField }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleFieldSelect = (fieldType) => {
    onAddField(fieldType);
    setIsOpen(false);
  };

  return (
    <Box ref={dropdownRef} sx={{ position: 'relative' }}>
      <Button variant="secondary" size="small" onClick={() => setIsOpen(!isOpen)} icon={Plus}>
        Add field
      </Button>

      {isOpen && (
        <Box
          sx={{
            position: 'absolute',
            top: '100%',
            left: 0,
            mt: '4px',
            bg: 'white',
            border: '1px solid',
            borderColor: 'border.subtle',
            borderRadius: '4px',
            boxShadow: '0px 1px 4px rgba(27, 36, 50, 0.06), 0px 2px 32px rgba(27, 36, 50, 0.06)',
            py: '8px',
            minWidth: '200px',
            zIndex: 1000,
          }}
        >
          {fieldTypes.map((fieldType) => (
            <Flex
              key={fieldType.type}
              onClick={() => handleFieldSelect(fieldType.type)}
              sx={{
                alignItems: 'center',
                gap: '8px',
                px: '16px',
                py: '4px',
                cursor: 'pointer',
                '&:hover': {
                  bg: 'neutral.20',
                },
              }}
            >
              <FieldTypeIcon type={fieldType.type} size={16} />
              <Box
                sx={{
                  fontSize: '14px',
                  color: 'text.main',
                }}
              >
                {fieldType.label}
              </Box>
            </Flex>
          ))}
        </Box>
      )}
    </Box>
  );
};

AddFieldDropdown.propTypes = {
  onAddField: PropTypes.func.isRequired,
};
